module.exports = __webpack_public_path__ + "static/media/23feb.3686c4be.jpg";